import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'medium',
  fullScreen = false,
  className = '',
}) => {
  const { colors } = useTheme();

  const sizeMap = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  const spinner = (
    <div className={`${spinnerSize} relative`}>
      <div className={`absolute inset-0 ${spinnerSize} border-4 ${colors.border} rounded-full`}></div>
      <div className={`absolute inset-0 ${spinnerSize} border-4 ${colors.primary} border-t-transparent rounded-full animate-spin`}></div>
    </div>
  );

  const content = (
    <div
      className={`flex flex-col items-center justify-center gap-4 ${
        fullScreen
          ? 'fixed inset-0 bg-white bg-opacity-90 dark:bg-gray-900 dark:bg-opacity-90 z-50'
          : 'py-8'
      } ${className}`}
    >
      {spinner}
      {message && (
        <p className={`text-sm ${colors.textSecondary} font-medium`}>{message}</p>
      )}
    </div>
  );

  return content;
};

export default LoadingSpinner;

